import { ISwiperData, SwiperImageExtension } from '../../shared/interfaces/swiper.interfaces';

const carouselImagePathPrefix = 'assets/images/home-carousel';

const currentFormat = SwiperImageExtension.PNG;

export const CarouselElements: ISwiperData[] = [
  {
    small: {
      image: `${carouselImagePathPrefix}/slide-4/Slider-100GB-202506-600-360${currentFormat}`,
    },
    smallMedium: {
      image: `${carouselImagePathPrefix}/slide-4/Slider-100GB-202506-767-576${currentFormat}`,
    },
    medium: {
      image: `${carouselImagePathPrefix}/slide-4/Slider-100GB-202506-959-768${currentFormat}`,
    },
    mediumLarge: {
      image: `${carouselImagePathPrefix}/slide-4/Slider-100GB-202506-1199-960${currentFormat}`,
    },
    large: {
      image: `${carouselImagePathPrefix}/slide-4/Slider-100GB-202506-1920-1200${currentFormat}`,
    },
    redirectPath: {
      url: '/mobil-szolgaltatas',
    },
  },
  {
    small: {
      image: `${carouselImagePathPrefix}/slide-5/Slider-50GB-202506-600-360${currentFormat}`,
    },
    smallMedium: {
      image: `${carouselImagePathPrefix}/slide-5/Slider-50GB-202506-767-576${currentFormat}`,
    },
    medium: {
      image: `${carouselImagePathPrefix}/slide-5/Slider-50GB-202506-959-768${currentFormat}`,
    },
    mediumLarge: {
      image: `${carouselImagePathPrefix}/slide-5/Slider-50GB-202506-1199-960${currentFormat}`,
    },
    large: {
      image: `${carouselImagePathPrefix}/slide-5/Slider-50GB-202506-1920-1200${currentFormat}`,
    },
    redirectPath: {
      url: '/mobil-szolgaltatas',
    },
  },
];
